<template>
  <div class="empty-state">
    <!-- Unauthorized Access State -->
    <div v-if="isUnauthorized" class="empty-state-content unauthorized">
      <svg class="empty-state-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
        <path d="M21.73 18l-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 9v4" stroke-width="2" stroke-linecap="round" />
        <path d="M12 17h.01" stroke-width="2" stroke-linecap="round" />
      </svg>
      <h3>Accès non autorisé</h3>
      <p>Vous devez avoir les droits administrateur pour accéder à cette section.</p>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="empty-state-content">
      <svg class="empty-state-icon error" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
        <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 8v5" stroke-width="2" stroke-linecap="round" />
        <path d="M12 16.8h.01" stroke-width="2" stroke-linecap="round" />
      </svg>
      <h3>Une erreur est survenue</h3>
      <p>{{ error }}</p>
    </div>

    <!-- Ticket Already Validated State -->
    <div v-else-if="variant === 'ticketValidated'" class="empty-state-content already-used">
      <svg class="empty-state-icon already-used" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <circle cx="12" cy="12" r="10" stroke-width="2" />
        <path d="M16 14s-1.5 2-4 2-4-2-4-2" stroke-width="2" stroke-linecap="round" />
        <line x1="9" y1="9" x2="9.01" y2="9" stroke-width="2" stroke-linecap="round" />
        <line x1="15" y1="9" x2="15.01" y2="9" stroke-width="2" stroke-linecap="round" />
      </svg>
      <h3>Ticket déjà validé</h3>
      <p v-if="validatedAt">Validé le {{ validatedAt }}</p>
      <p v-else>Ce ticket a déjà été utilisé.</p>
    </div>

    <!-- No trip caroussel state -->
    <div v-else-if="variant === 'caroussel'" class="empty-state-content">
      <svg class="empty-state-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <circle cx="12" cy="12" r="10" stroke-width="2" />
        <path d="M16 16s-1.5-2-4-2-4 2-4 2" stroke-width="2" stroke-linecap="round" />
        <line x1="9" y1="9" x2="9.01" y2="9" stroke-width="2" stroke-linecap="round" />
        <line x1="15" y1="9" x2="15.01" y2="9" stroke-width="2" stroke-linecap="round" />
      </svg>
      <h3>Aucun trajet avenir à vous proposer.</h3>
      <p>{{ error }}</p>
    </div>

    <!-- Error State Payement Cancelled -->
    <div v-else-if="variant === 'cancelledPayment'" class="empty-state-content">
      <svg class="empty-state-icon error" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
        <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 8v5" stroke-width="2" stroke-linecap="round" />
        <path d="M12 16.8h.01" stroke-width="2" stroke-linecap="round" />
      </svg>
      <h3>Le paiement de ce ticket à échoué</h3>
      <p>{{ error }}</p>
    </div>

    <!-- Welcome State (nouveau utilisateur sans tickets) -->
    <div v-else-if="variant === 'welcome'" class="empty-state-content welcome">
      <!--<svg class="empty-state-icon welcome-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="12" cy="7" r="4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 14v.01" stroke-width="2" stroke-linecap="round"/>
      </svg>-->
      <div class="welcome-content">
        <img src="../assets/images/undraw_meditation_k4oa.png">
        <h3>{{ emptyMessage }}</h3>
        <slot name="description"></slot>
        <slot name="actions"></slot>
      </div>
    </div>

    <!-- Empty State (par défaut) -->
    <div v-else-if="isEmpty" class="empty-state-content">
      <svg class="empty-state-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <circle cx="12" cy="12" r="10" stroke-width="2" />
        <path d="M16 16s-1.5-2-4-2-4 2-4 2" stroke-width="2" stroke-linecap="round" />
        <line x1="9" y1="9" x2="9.01" y2="9" stroke-width="2" stroke-linecap="round" />
        <line x1="15" y1="9" x2="15.01" y2="9" stroke-width="2" stroke-linecap="round" />
      </svg>
      <h3>Aucun résultat</h3>
      <p>{{ emptyMessage }}</p>
      <div v-if="$slots.actions" class="empty-actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  error: {
    type: String,
    default: null
  },
  isEmpty: {
    type: Boolean,
    default: false
  },
  isUnauthorized: {
    type: Boolean,
    default: false
  },
  emptyMessage: {
    type: String,
    default: 'Aucun résultat trouvé'
  },
  variant: {
    type: String,
    default: null
  }, // 'ticketValidated', 'welcome'
  validatedAt: {
    type: String,
    default: null
  }
})
</script>

<style scoped>
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  flex: 1;
}

.empty-state-content {
  text-align: center;
}

.empty-state-icon {
  width: 120px;
  height: 120px;
  margin: 0 auto 1.5rem;
  animation: slideInIcon 0.4s ease-out;
  color: var(--color-grey-medium);
}

@keyframes slideInIcon {
  from {
    opacity: 0;
    transform: scale(0.8);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.empty-state-content .empty-state-icon.error,
.empty-state-content.unauthorized,
.empty-state-content.unauthorized .empty-state-icon,
.empty-state-content.unauthorized h3,
.empty-state-content.unauthorized p {
  color: var(--color-terracotta);
}

.empty-state-content h3 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: var(--color-text-primary);
  font-weight: 600;
}

.empty-state-content p {
  color: var(--color-text-secondary);
  line-height: 1.6;
  font-size: 0.95rem;
}

/* Welcome state styling */
.empty-state-content.welcome .welcome-icon {
  color: var(--color-feuille);
}

.empty-state-content.welcome h3 {
  color: var(--color-feuille);
  font-size: 1.75rem;
}

.welcome-content {
  margin: 0 auto;
  display: flex;
  flex-flow: row wrap;
  gap: 1rem;
  justify-content: center;
}

:deep(.welcome-content p) {
  margin-bottom: 0.75rem;
  font-size: 1rem;
}

:deep(.welcome-content .btn-group) {
  flex: 1 1 100%;
  justify-content: center;
}

.empty-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .empty-state {
    padding: 1.5rem;
  }

  .empty-state-icon {
    width: 100px;
    height: 100px;
  }

  .empty-state-content h3 {
    font-size: 1.25rem;
  }

  .empty-state-content.welcome h3 {
    font-size: 1.5rem;
  }

  .empty-actions {
    flex-direction: column;
  }

  .empty-actions :deep(.btn) {
    width: 100%;
  }
}
</style>
